// extracted by mini-css-extract-plugin
module.exports = {"image":"image_buqE_d","imageLoaded":"imageLoaded_3A9Sm8"};